import { ControlValueAccessor } from '@angular/forms';
import { Input } from '@angular/core';
import { OptionsProvider } from './providers/options-provider';

export type TagModel = string | {[key: string]: any};
/**
 * @param {?} obj
 * @return {?}
 */
export function isObject(obj: any): boolean {
    return obj === Object(obj);
}
export class TagInputAccessor implements ControlValueAccessor {
private _items: TagModel[] = [];
private _onTouchedCallback: () => void;
private _onChangeCallback: (items: TagModel[]) => void;
/**
 * \@name displayBy
 */
public displayBy: string = OptionsProvider.defaults.tagInput.displayBy;
/**
 * \@name identifyBy
 */
public identifyBy: string = OptionsProvider.defaults.tagInput.identifyBy;
/**
 * @return {?}
 */
public get items(): TagModel[] {
        return this._items;
    };
/**
 * @param {?} items
 * @return {?}
 */
public set items(items: TagModel[]) {
        this._items = items;
        this._onChangeCallback(this._items);
    }
/**
 * @return {?}
 */
public onTouched() {
        this._onTouchedCallback();
    }
/**
 * @param {?} items
 * @return {?}
 */
public writeValue(items: any[]) {
        this._items = items || [];
    }
/**
 * @param {?} fn
 * @return {?}
 */
public registerOnChange(fn: any) {
        this._onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
public registerOnTouched(fn: any) {
        this._onTouchedCallback = fn;
    }
/**
 * \@name getItemValue
 * @param {?} item
 * @return {?}
 */
public getItemValue(item: TagModel): string {
        return isObject(item) ? item[this.identifyBy] : item;
    }
/**
 * \@name getItemDisplay
 * @param {?} item
 * @return {?}
 */
public getItemDisplay(item: TagModel): string {
        return isObject(item) ? item[this.displayBy] : item;
    }
/**
 * \@name getItemsWithout
 * @param {?} index
 * @return {?}
 */
protected getItemsWithout(index: number): TagModel[] {
        return this.items.filter((item, position) => position !== index);
    }
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'displayBy': [{ type: Input },],
'identifyBy': [{ type: Input },],
};
}

function TagInputAccessor_tsickle_Closure_declarations() {
/** @type {?} */
TagInputAccessor.propDecorators;
/** @type {?} */
TagInputAccessor.prototype._items;
/** @type {?} */
TagInputAccessor.prototype._onTouchedCallback;
/** @type {?} */
TagInputAccessor.prototype._onChangeCallback;
/**
 * \@name displayBy
 * @type {?}
 */
TagInputAccessor.prototype.displayBy;
/**
 * \@name identifyBy
 * @type {?}
 */
TagInputAccessor.prototype.identifyBy;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
